import esReportCopy from '../../../locales/es/report.json';

type ReportCopySchema = typeof esReportCopy;

const FALLBACK_LOCALE = 'es-ES';

const REPORT_COPY_MAP: Record<string, ReportCopySchema> = {
  es: esReportCopy,
  'es-ES': esReportCopy,
};

export type ReportCopy = ReportCopySchema;

export function getReportCopy(locale: string | null | undefined): ReportCopy {
  if (!locale) {
    return REPORT_COPY_MAP[FALLBACK_LOCALE] ?? esReportCopy;
  }

  const normalized = locale.toLowerCase();
  return (
    REPORT_COPY_MAP[normalized] ??
    REPORT_COPY_MAP[locale] ??
    REPORT_COPY_MAP[FALLBACK_LOCALE] ??
    esReportCopy
  );
}
